module.exports = __webpack_public_path__ + "img/consult_info3.9e2568b8.png";